import createReactComponent from '../createReactComponent';
var FileOutput = createReactComponent('FileOutput', [['path', {
  d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4',
  key: '17a36r'
}], ['path', {
  d: 'M14 2v6h6',
  key: '1kof46'
}], ['path', {
  d: 'M2 15h10',
  key: 'jfw4w8'
}], ['path', {
  d: 'M5 12l-3 3 3 3',
  key: '15170t'
}]]);
export default FileOutput;